import { FC, memo, useMemo, useState } from "react";
import { IOption, Select } from "../../../selects/select";
import { TextInput } from "../../../controls/inputs";
import { SearchButton } from "../../../buttons/iconButtons/action/MainCollection";
import styles from "../styles/DocumentSearchPanel.module.scss"


interface ISearchParams {
    searchStore: string;
    searchOption: string;
}

interface IBaseProps {
    onSubmit: (searchParams: ISearchParams) => void;
    options?: IOption[];
    selectedItem?: [IGridRow | undefined, (value: IGridRow | undefined) => void];
    query?: string
}
interface IDocumentSearchPanelProps extends IBaseProps { }

interface ISearchFormProps extends IBaseProps {
    memoizedOptions: IOption[];
}

export const DocumentSearchPanel: FC<IDocumentSearchPanelProps> = ({ options, children, ...rest }) => {

    // для запрета повтороного рендеринга компонента.
    const memoizedOptions = useMemo(() => options || [{ displayName: 'Содержит товар', value: 'goodsName' }], []);

    return (
        <>
            <SearchForm memoizedOptions={memoizedOptions} {...rest} />
        </>
    )
}

const SearchForm: FC<ISearchFormProps> = memo(({ memoizedOptions, onSubmit, selectedItem, query }) => {
    const [searchStore, setSearchStore] = useState<string>(query ?? '');
    const [searchOption, setSearchOption] = useState<IOption>(memoizedOptions[0]);
    const handleSubmit = (event: React.FormEvent) => {
        event.preventDefault();
        selectedItem?.[1](undefined);
        if (onSubmit) {
            onSubmit({ searchStore, searchOption: searchOption.value as string });
        }
    };


    return (
        <form onSubmit={handleSubmit}>
            <div className={styles.searchFormContainer}>
                <TextInput
                    className={styles.searchFormContainer_searchInput}
                    value={searchStore}
                    onChange={setSearchStore}
                />
                <SearchButton
                    buttonType={'submit'}
                    sizeVariant={'normal'}
                />
                <Select
                    className={styles.searchFormContainer_searchSelect}
                    defaultOption={memoizedOptions[0]}
                    onSelect={(option) => setSearchOption(option)}
                    value={searchOption}
                    options={memoizedOptions}
                />
            </div>
        </form>
    );
}
);